var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSightseenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1326_1250",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 31V1.00009H1V31H30.9999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1326_1250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.939 8.97094H3.44799C2.06737 8.97094 0.937498 10.1007 0.937498 11.4813V28.5521C0.937498 29.9328 2.06737 31.0625 3.44799 31.0625H28.5518C29.9325 31.0625 31.0624 29.9328 31.0624 28.5521V11.4813C31.0624 10.1006 29.9325 8.97094 28.5518 8.97094H27.8509",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3952 2.71125L21.0614 0.937571L20.9306 4.71143L17.7278 6.71155L20.9306 8.71167L21.0614 12.4855L24.3952 10.7119L27.7287 12.4855L27.8597 8.71167L31.0624 6.71155L27.8597 4.71143L27.7287 0.937571L24.3952 2.71125Z",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.97079 21.0208C8.97079 24.9029 12.1179 28.05 16 28.05C19.8823 28.05 23.0291 24.9029 23.0291 21.0208C23.0291 17.1388 19.8823 13.9917 16 13.9917C12.1179 13.9917 8.97079 17.1388 8.97079 21.0208Z",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9833 21.0208C11.9833 23.2392 13.7815 25.0376 16 25.0376C18.2183 25.0376 20.0166 23.2392 20.0166 21.0208C20.0166 18.8025 18.2183 17.0042 16 17.0042C13.7815 17.0042 11.9833 18.8025 11.9833 21.0208Z",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9792 8.97095H4.95424V5.95839H10.9792V8.97095Z",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96248 13.4897C6.96248 14.3215 6.28804 14.996 5.45623 14.996C4.62449 14.996 3.95005 14.3215 3.95005 13.4897C3.95005 12.6578 4.62449 11.9834 5.45623 11.9834C6.28804 11.9834 6.96248 12.6578 6.96248 13.4897Z",
    stroke: "#707170",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSightseenIcon);
export default __webpack_public_path__ + "static/media/sightseen-icon.2ca5976c.svg";
export { ForwardRef as ReactComponent };